export const DataFields = (t) => {
  return [
    {
      name: "",
      fields: [
        {
          id: "name",
          name: t('qrcode_form_name'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "description",
          name: t('qrcode_form_description'),
          type: "text",
          required: false,
          defaultValue: "",
          size: "small"
        },
        {
          id: "menu",
          name: t('qrcode_form_menu'),
          type: "select",
          containerOptions: "menus",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "active",
          name: t('qrcode_form_active'),
          type: "switch",
          required: true,
          defaultValue: false,
          size: "small"
        },
      ]
    }
  ]
}